import { OPTION_YES } from '../../constants/forms'
import { FREQUENCY_IMPRESSIONS, FREQUENCY_OPTION, FREQUENCY_TIME_UNIT } from './fields'

export const formatFrequencyToBE = values => {
  if (values[FREQUENCY_OPTION] === OPTION_YES) {
    return {
      time_unit: values[FREQUENCY_TIME_UNIT],
      time_unit_count: 1,
      max_impressions: values[FREQUENCY_IMPRESSIONS]
    }
  } else {
    return {
      unlimited: true
    }
  }
}
